// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPaste } from '@ni/nimble-components/dist/esm/icons/paste';
import { wrap } from '../utilities/react-wrapper';

export { type IconPaste };
export const NimbleIconPaste = wrap(IconPaste);